import { useCallback, useRef } from 'react'

export const useDebounce = <T extends unknown[]>(fn: (...args: T) => void, timeout: number): ((...args: T) => void) => {
  const ref = useRef<NodeJS.Timeout>()

  const restart = useCallback(
    (...args: T) => {
      const id = setTimeout(() => fn(...args), timeout)

      if (ref.current) clearTimeout(ref.current)
      ref.current = id
    },
    [timeout, fn],
  )

  return restart
}
